import jsPDF from 'jspdf';
import logoNutraMix from '../imagenes/Nutramix.png';
import pieDePagina from '../imagenes/pieDePagina.png';
import html2canvas from 'html2canvas';
import firmaMaria from '../imagenes/firmaMariaLarios.png'

export const GenerarPDFDevoluciones = async ({ fechaInicio, fechaFin, data, barraRef2, barraRef3, barraRef1 }) => {
    const pdf = new jsPDF('p', 'mm', 'letter');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();




    let pageCount = 1;
    const marginBottom = 40;

    const addHeader = () => {
        pdf.addImage(logoNutraMix, 'PNG', pageWidth - 50, 5, 30, 15);
        pdf.setFontSize(10);
       // pdf.text("Página " + pageCount, 25, 10);
    };

    const addFooter = () => {

        const anchoImg = 120;
        const altoImg = 10;
        const x = (pageWidth - anchoImg) / 2;
        const y = pageHeight - altoImg - 20;

        pdf.addImage(pieDePagina, 'PNG', x, y, anchoImg, altoImg);
        pdf.setFont('arial', 'normal');
        pdf.setFontSize(11);
        const texto = 'Km. 173.5 Carretera al Pacífico, Santa Cruz Mulúa, Retalhuleu. Guatemala C.A.';
        const xTexto = x + (anchoImg - pdf.getTextWidth(texto)) / 2;
        pdf.text(texto, xTexto, y + altoImg + 8);
    };

    // Página 1
    addHeader();
    addFooter();

    pdf.setFont('arial', 'bold');

    const titulo1 = 'REPORTE DE DEVOLUCIONES DE PRODUCTO TERMINADO';
    const titulo2 = '“PLANTACIONES DEL SUR, S.A”';

    let y = 25; // posición inicial en Y

    pdf.text(titulo1, (pageWidth - pdf.getTextWidth(titulo1)) / 2, y);

    y += 7

    pdf.text(titulo2, (pageWidth - pdf.getTextWidth(titulo2)) / 2, y);

    /*const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };
*/
    const inicio = fechaInicio;
    const fin = fechaFin;

    pdf.setFont('arial', 'normal');
    pdf.setFontSize(11);
    y += 5;

    pdf.text("Periodo: " + inicio + " - " + fin, 25, y);

    pdf.setFontSize(12);

    y += 5
    //pdf.text("En la siguiente tabla se desglosan las devoluciones de producto terminado registradas durante", 25, y);
justifyLine(pdf, "En la siguiente tabla se desglosan las devoluciones de producto terminado registradas durante", 25, y, 170);
    y += 5
    //pdf.text("el período evaluado, indicando cliente, procedencia, producto, cantidad y motivo reportado, con", 25, y);
    justifyLine(pdf, "el período evaluado, indicando cliente, procedencia, producto, cantidad y motivo reportado, con", 25, y, 170);
    y += 5
    //pdf.text("el fin de identificar tendencias y oportunidades de mejora en los procesos de calidad y logística:", 25, y);
justifyLine(pdf, "el fin de identificar tendencias y oportunidades de mejora en los procesos de calidad y logística:", 25, y, 170);
    // Tabla
    const headers = ["Fecha", "Cliente", "Procedencia", "Producto", "Cantidad", "Motivo de devolución"];
    const colWidths = [25, 30, 35, 35, 20, 45];

    y = 60;

    const drawTableHeader = () => {
        let x = 15;
        headers.forEach((header, i) => {
            pdf.text(header, x + 2, y + 5);
            pdf.rect(x, y, colWidths[i], 8);
            x += colWidths[i];
        });
        y += 8;
    };

    drawTableHeader();

    const checkSpaceForRows = (neededHeight) => {
        if (y + neededHeight > pageHeight - marginBottom) {
            pdf.addPage();
            pageCount++;
            addHeader();
            addFooter();
            y = 30;
            drawTableHeader();
        }
    };

    data.forEach((row) => {
        const values = [
            row.fecha,
            row.cliente,
            row.procedencia,
            row.producto,
            String(row.cantidad),
            row.motivo_devolucion
        ];

        let rowHeight = 8;
        values.forEach((val, i) => {
            const textLines = pdf.splitTextToSize(val || "", colWidths[i] - 4);
            const cellHeight = textLines.length * 5;
            if (cellHeight > rowHeight) rowHeight = cellHeight;
        });

        checkSpaceForRows(rowHeight);

        let xCell = 15;
        values.forEach((val, i) => {
            const textLines = pdf.splitTextToSize(val || "", colWidths[i] - 4);
            if (i === 4) {
                const cellCenterX = xCell + (colWidths[i] / 2);
                const textWidth = pdf.getTextWidth(val || "");
                const centeredX = cellCenterX - (textWidth / 2);
                pdf.text(val || "", centeredX, y + 5);
            } else {
                pdf.text(textLines, xCell + 2, y + 5);
            }
            pdf.rect(xCell, y, colWidths[i], rowHeight);
            xCell += colWidths[i];
        });

        y += rowHeight;
    });

    // Sección de gráficos: validar bloque completo
  /*  const graphicsBlockHeight = 60; // título + subtítulo + íconos
    if (y + graphicsBlockHeight > pageHeight - marginBottom) {
        pdf.addPage();
        pageCount++;
        addHeader();
        addFooter();
        y = 30; // reinicia arriba
    }

    pdf.addPage();
    pageCount++;
    addHeader();
    addFooter();

    y = 20; // reinicia arriba
*/

function ensureNewPageIfNeeded(y, blockHeight, pageHeight, marginBottom) {
    // Si el bloque no cabe en la página actual
    if (y + blockHeight > pageHeight - marginBottom) {
        pdf.addPage();
        pageCount++;
        addHeader();
        addFooter();
        y = 30; // reinicia arriba
    }
    return y;
}


const graphicsBlockHeight = 120; // altura estimada del bloque
y = ensureNewPageIfNeeded(y, graphicsBlockHeight, (pageHeight -50), marginBottom);
    // Título GRÁFICOS
    const grafico = 'GRÁFICOS';
    pdf.setFont('arial', 'bold');
    pdf.setFontSize(14);
    y += 10;
    pdf.text(grafico, (pageWidth - pdf.getTextWidth(grafico)) / 2, y);

    // Subtítulo
    const grafico1 = 'Gráfico 1. Distribución por cliente afectado';
    pdf.setFontSize(12);
    y += 10;
    pdf.text(grafico1, 25, y);

    // Aquí iría el renderizado de íconos/gráfico

    // pdf.addImage(...);
    const canvas1 = await html2canvas(barraRef2.current);
    const imgData1 = canvas1.toDataURL('image/png');

    y += 10;

    pdf.addImage(imgData1, 'PNG', -30, y, 250, 70);


    //Grafico 2 producto devuelto

    const grafico2 = 'Gráfico 2.  Distribución por producto devuelto';
    pdf.setFontSize(12);
    y += 90;
    pdf.text(grafico2, 25, y);

    // Aquí iría el renderizado de íconos/gráfico
    y += 10;
    // pdf.addImage(...);
    const canvas2 = await html2canvas(barraRef3.current);
    const imgData2 = canvas2.toDataURL('image/png');

    pdf.addImage(imgData2, 'PNG', -20, y, 250, 70);




    //Grafico 3

    pdf.addPage();
    pageCount++;
    addHeader();
    addFooter();
    y = 20; // reinicia arriba


    const grafico3 = 'Gráfico 3. Distribución por motivo de devolución';
    pdf.setFontSize(12);
    y += 5;
    pdf.text(grafico3, 25, y);

    // Aquí iría el renderizado de íconos/gráfico
    y += 5;
    // pdf.addImage(...);
    const canvas3 = await html2canvas(barraRef1.current);
    const imgData3 = canvas3.toDataURL('image/png');

    pdf.addImage(imgData3, 'PNG', -30, y, 250, 70);


    pdf.addPage();
    pageCount++;
    addHeader();
    addFooter();
    y = 5; // reinicia arriba
    // Supongamos que ya tienes el resultado del topClientesDevoluciones

    const devoluciones = 'RESUMEN DE DEVOLUCIONES';
    pdf.setFont('arial', 'bold');
    pdf.setFontSize(14);
    y += 15;
    pdf.text(devoluciones, (pageWidth - pdf.getTextWidth(devoluciones)) / 2, y);
    /*
        const topDevoluciones = (data, tipo = "cliente") => {
            // tipo puede ser "cliente", "producto" o "motivo"
    
            // Acumulador
            const acumulador = {};
    
            data.forEach((row) => {
                let clave;
                switch (tipo) {
                    case "producto":
                        clave = row.producto;
                        break;
                    case "motivo":
                        clave = row.motivo_devolucion;
                        break;
                    default:
                        clave = row.cliente;
                }
    
                if (!acumulador[clave]) {
                    acumulador[clave] = 0;
                }
                acumulador[clave] += 1; // frecuencia (no cantidad)
            });
    
            // Ordenar descendente
            const ordenados = Object.entries(acumulador)
                .sort((a, b) => b[1] - a[1]);
    
            if (ordenados.length === 0) return [];
    
            const top1 = ordenados[0];
            const segundoValor = ordenados[1] ? ordenados[1][1] : null;
            const segundos = ordenados.filter(([_, total]) => total === segundoValor);
    
            let resultado;
    
            if (segundos.length > 2) {
                // Más de 2 empatados en segundo lugar
                resultado = [top1, segundos[0]]; // solo uno en segundo
                // en tercer lugar, elegir el primero en orden alfabético
                const tercerosOrdenados = segundos.slice(1).sort((a, b) => a[0].localeCompare(b[0]));
                resultado.push(tercerosOrdenados[0]);
            } else {
                // Caso normal: top 3 directos
                resultado = ordenados.slice(0, 3);
                // Si hay empate en tercer lugar, elegir el primero en orden alfabético
                if (resultado[2]) {
                    const tercerValor = resultado[2][1];
                    const terceros = ordenados.filter(([_, total]) => total === tercerValor);
                    if (terceros.length > 1) {
                        const tercerosOrdenados = terceros.sort((a, b) => a[0].localeCompare(b[0]));
                        resultado[2] = tercerosOrdenados[0];
                    }
                }
            }
    
            return resultado.map(([clave, veces]) => ({ [tipo]: clave, veces }));
        };*/

/*
    const topDevoluciones = (data, tipo = "cliente") => {
        // tipo puede ser "cliente", "producto" o "motivo"

        const acumulador = {};

        data.forEach((row) => {
            let clave;
            switch (tipo) {
                case "producto":
                    clave = row.producto;
                    break;
                case "motivo":
                    clave = row.motivo_devolucion;
                    break;
                default:
                    clave = row.cliente;
            }

            if (!acumulador[clave]) {
                acumulador[clave] = 0;
            }
            acumulador[clave] += Number(row.cantidad) || 0; // acumular cantidad
        });

        const ordenados = Object.entries(acumulador)
            .sort((a, b) => b[1] - a[1]);

        if (ordenados.length === 0) return [];

        const top1 = ordenados[0];
        const segundoValor = ordenados[1] ? ordenados[1][1] : null;
        const segundos = ordenados.filter(([_, total]) => total === segundoValor);

        let resultado;

        if (segundos.length > 2) {
            // Más de 2 empatados en segundo lugar
            resultado = [top1, segundos[0]];
            const tercerosOrdenados = segundos.slice(1).sort((a, b) => a[0].localeCompare(b[0]));
            resultado.push(tercerosOrdenados[0]);
        } else {
            resultado = ordenados.slice(0, 3);
            if (resultado[2]) {
                const tercerValor = resultado[2][1];
                const terceros = ordenados.filter(([_, total]) => total === tercerValor);
                if (terceros.length > 1) {
                    const tercerosOrdenados = terceros.sort((a, b) => a[0].localeCompare(b[0]));
                    resultado[2] = tercerosOrdenados[0];
                }
            }
        }

        return resultado.map(([clave, total]) => ({ [tipo]: clave, total }));
    };*/

    const topDevoluciones = (data, tipo = "cliente") => {
    const acumulador = {};

    // Acumular valores
    data.forEach((row) => {
        let clave;
        switch (tipo) {
            case "producto":
                clave = row.producto?.trim();
                break;
            case "motivo":
                clave = row.motivo_devolucion?.trim();
                break;
            default:
                clave = row.cliente?.trim();
        }

        if (!acumulador[clave]) {
            acumulador[clave] = 0;
        }

        acumulador[clave] += Number(row.cantidad) || 0;
    });

    // Ordenar por cantidad descendente y luego alfabético
    const ordenados = Object.entries(acumulador)
        .sort((a, b) => {
            if (b[1] !== a[1]) return b[1] - a[1];
            return a[0].localeCompare(b[0]);
        });

    // Tomar los primeros 3
    return ordenados.slice(0, 3).map(([clave, total]) => ({
        [tipo]: clave,
        total
    }));
};


const topDevolucionesCliente = (data, tipo = "cliente") => {
    const acumulador = {};

    data.forEach((row) => {
        let clave;
        switch (tipo) {
            case "producto":
                clave = row.producto;
                break;
            case "motivo":
                clave = row.motivo_devolucion;
                break;
            default:
                clave = row.cliente; // solo cliente como clave
        }

        if (!acumulador[clave]) {
            acumulador[clave] = { valor: 0, procedencia: row.procedencia };
        }

        if (tipo === "cliente") {
            acumulador[clave].valor += 1;
        } else {
            acumulador[clave].valor += Number(row.cantidad) || 0;
        }
    });

    const ordenados = Object.entries(acumulador)
        .sort((a, b) => {
            if (b[1].valor !== a[1].valor) return b[1].valor - a[1].valor;
            return a[0].localeCompare(b[0]);
        });

    return ordenados.slice(0, 3).map(([cliente, datos]) => ({
        cliente,
        procedencia: datos.procedencia,
        valor: datos.valor
    }));
};


/*
    const topDevolucionesCliente = (data, tipo = "cliente") => {
    const acumulador = {};

    // Acumular valores
    data.forEach((row) => {
        let clave;
        switch (tipo) {
            case "producto":
                clave = row.producto;
                break;
            case "motivo":
                clave = row.motivo_devolucion;
                break;
            default:
                clave = row.cliente;
        }

        if (!acumulador[clave]) {
            acumulador[clave] = 0;
        }

        if (tipo === "cliente") {
            acumulador[clave] += 1; // frecuencia
        } else {
            acumulador[clave] += Number(row.cantidad) || 0; // cantidad
        }
    });

    // Ordenar por valor descendente y luego alfabético
    const ordenados = Object.entries(acumulador)
        .sort((a, b) => {
            if (b[1] !== a[1]) return b[1] - a[1]; // primero frecuencia
            return a[0].localeCompare(b[0]);       // luego nombre
        });

    // Tomar los primeros 3 distintos
    const resultado = [];
    const usados = new Set();

    for (let i = 0; i < ordenados.length && resultado.length < 3; i++) {
        const [clave, valor] = ordenados[i];
        if (!usados.has(clave)) {
            resultado.push({ [tipo]: clave, valor });
            usados.add(clave);
        }
    }

    return resultado;
};
*/
/*
    const topDevolucionesMotivo = (data, tipo = "motivo") => {
        const acumulador = {};

        data.forEach((row) => {
            let clave;
            switch (tipo) {
                case "producto":
                    clave = row.producto;
                    break;
                case "motivo":
                    clave = row.motivo_devolucion;
                    break;
                default:
                    clave = row.cliente;
            }

            if (!acumulador[clave]) {
                acumulador[clave] = 0;
            }

            if (tipo === "producto") {
                acumulador[clave] += Number(row.cantidad) || 0; // cantidad total
            } else {
                acumulador[clave] += 1; // frecuencia (cliente y motivo)
            }
        });

        const ordenados = Object.entries(acumulador)
            .sort((a, b) => b[1] - a[1]);

        if (ordenados.length === 0) return [];

        const top1 = ordenados[0];
        const segundoValor = ordenados[1] ? ordenados[1][1] : null;
        const segundos = ordenados.filter(([_, total]) => total === segundoValor);

        let resultado;

        if (segundos.length > 2) {
            resultado = [top1, segundos[0]];
            const tercerosOrdenados = segundos.slice(1).sort((a, b) => a[0].localeCompare(b[0]));
            resultado.push(tercerosOrdenados[0]);
        } else {
            resultado = ordenados.slice(0, 3);
            if (resultado[2]) {
                const tercerValor = resultado[2][1];
                const terceros = ordenados.filter(([_, total]) => total === tercerValor);
                if (terceros.length > 1) {
                    const tercerosOrdenados = terceros.sort((a, b) => a[0].localeCompare(b[0]));
                    resultado[2] = tercerosOrdenados[0];
                }
            }
        }

        return resultado.map(([clave, valor]) => ({ [tipo]: clave, valor }));
    };*/
    const topDevolucionesMotivo = (data, tipo = "motivo") => {
    const acumulador = {};

    // Acumular valores
    data.forEach((row) => {
        let clave;
        switch (tipo) {
            case "producto":
                clave = row.producto?.trim();
                break;
            case "motivo":
                clave = row.motivo_devolucion?.trim();
                break;
            default:
                clave = row.cliente?.trim();
        }

        if (!acumulador[clave]) {
            acumulador[clave] = 0;
        }

        if (tipo === "producto") {
            acumulador[clave] += Number(row.cantidad) || 0; // cantidad total
        } else {
            acumulador[clave] += 1; // frecuencia
        }
    });

    // Ordenar por valor descendente y luego alfabético
    const ordenados = Object.entries(acumulador)
        .sort((a, b) => {
            if (b[1] !== a[1]) return b[1] - a[1];
            return a[0].localeCompare(b[0]);
        });

    // Tomar los primeros 3
    return ordenados.slice(0, 3).map(([clave, valor]) => ({
        [tipo]: clave,
        valor
    }));
};



    const resultado = topDevolucionesCliente(data, 'cliente'); // Cambia a "motivo" o "cliente" según lo que quieras destacar

    const resultado2 = topDevoluciones(data, 'producto'); // Cambia a "motivo" o "cliente" según lo que quieras destacar
    const resultado3 = topDevolucionesMotivo(data, 'motivo'); // Cambia a "motivo" o "cliente" según lo que quieras destacar

    pdf.setFont('arial', 'normal');
    pdf.setFontSize(11);
    y += 10;
    //pdf.text("Con base en el análisis de las devoluciones registradas durante el período evaluado, se ", 25, y);
    justifyLine(pdf, "Con base en el análisis de las devoluciones registradas durante el período evaluado, se ", 25, y, 170);
    y += 5;
    //pdf.text("identifican los siguientes puntos relevantes:", 25, y);
    justifyLine(pdf, "identifican los siguientes puntos relevantes:", 25, y, 170);
    pdf.setFont('arial', 'bold');
    y += 5;
    pdf.text("a.	Clientes con mayor incidencia de devoluciones", 25, y);
    //justifyLine(pdf, "a.	Clientes con mayor incidencia de devoluciones", 25, y, 170);
    y += 5;
    pdf.setFont('arial', 'normal');
    justifyLine(pdf, "El siguiente listado corresponde a los clientes que han incurrido con mayor frecuencia en", 25, y, 170);
    y += 5;
    justifyLine(pdf, "devoluciones de producto terminado, debido a distintas desviaciones asociadas a calidad,", 25, y, 170);
    y += 5;
    //justifyLine(pdf, "manipulación y logística:", 25, y, 170);

    pdf.text("manipulación y logística:", 25, y);

    y += 5;
    // Texto inicial
    pdf.setFontSize(11);
    // posición inicial en Y

    resultado.forEach((c, index) => {
        y += 5; // espacio entre líneas
        pdf.text((index + 1) + "- " + c.cliente.toUpperCase()+" - "+c.procedencia.toUpperCase(), 25, y);
    });

    function justifyLine(pdf, line, x, y, maxWidth) {
        const words = line.trim().split(/\s+/);
        if (words.length === 1) {
            pdf.text(line, x, y); // si solo hay una palabra, la imprime normal
            return;
        }

        const totalWordsWidth = words.reduce((acc, w) => acc + pdf.getTextWidth(w), 0);
        const spaceCount = words.length - 1;
        const extraSpace = (maxWidth - totalWordsWidth) / spaceCount;

        let cursorX = x;
        words.forEach((w, idx) => {
            pdf.text(w, cursorX, y);
            cursorX += pdf.getTextWidth(w) + (idx < words.length - 1 ? extraSpace : 0);
        });
    }


    y += 10;
    //pdf.text("Derivado de lo anterior, se recomienda que en la semana en curso se fortalezcan los controles ", 25, y);
    justifyLine(pdf, "Derivado de lo anterior, se recomienda que en la semana en curso se fortalezcan los controles", 25, y, 170);
    y += 5;
    //pdf.text("de revisión previo al despacho, tanto de producto como de los vehículos que transportan el", 25, y);
    justifyLine(pdf, "de revisión previo al despacho, tanto de producto como de los vehículos que transportan el", 25, y, 170);
    y += 5;
    //pdf.text("alimento hacia estos clientes.  Mejorar los controles sobre condiciones de almacenamiento y ", 25, y);
    justifyLine(pdf, "alimento hacia estos clientes.  Mejorar los controles sobre condiciones de almacenamiento y ", 25, y, 170);
    y += 5;
    //pdf.text("transporte, garantizando que el producto cumpla con las especificaciones antes de su ", 25, y);
    justifyLine(pdf, "transporte, garantizando que el producto cumpla con las especificaciones antes de su ", 25, y, 170);
    y += 5;

    //pdf.text("distribución.", 25, y);
    justifyLine(pdf, "distribución.", 25, y, 170);

    pdf.setFont('arial', 'bold');
    y += 10;
    pdf.text("b.	Productos con mayor número de devoluciones", 25, y);
    y += 5;
    pdf.setFont('arial', 'normal');
    //pdf.text("Durante el período analizado, los productos que presentaron mayor recurrencia en :", 25, y);
    justifyLine(pdf, "Durante el período analizado, los productos que presentaron mayor recurrencia en ", 25, y, 170);
    y += 5;
    pdf.text("devoluciones fueron:", 25, y);
    y += 5;

    resultado2.forEach((c, index) => {
        y += 5; // espacio entre líneas
        pdf.text((index + 1) + "- " + c.producto.toUpperCase(), 25, y);
    });

    y += 10;
    pdf.setFont('arial', 'bold');

    pdf.text("c.	Principales causas identificadas", 25, y);
    y += 5;
    pdf.setFont('arial', 'normal');
    //pdf.text("Las causas de devoluciones recurrentes durante el período solicitado son:", 25, y);
    justifyLine(pdf, "Las causas de devoluciones recurrentes durante el período solicitado son:", 25, y, 170);
    y += 5;
    resultado3.forEach((c, index) => {
        y += 5; // espacio entre líneas
        const partes = c.motivo.split(" - ");
        const split = partes.slice(2).join(" - ");
        pdf.text((index + 1) + "- " + c.motivo.toUpperCase(), 25, y);
    });

    y += 10;

    //pdf.text("Con el fin de evitar devoluciones por los motivos antes mencionados, se recomienda fortalecer", 25, y);
    justifyLine(pdf, "Con el fin de evitar devoluciones por los motivos antes mencionados, se recomienda fortalecer", 25, y, 170);
    y += 5;

    //pdf.text("los controles integrales a lo largo del proceso de producción, almacenamiento y despacho, ", 25, y);
    justifyLine(pdf, "los controles integrales a lo largo del proceso de producción, almacenamiento y despacho, ", 25, y, 170);
    y += 5;


    //pdf.text("asegurando que el producto cumpla con las condiciones de calidad, identificación, estado físico,  ", 25, y);
    justifyLine(pdf, "asegurando que el producto cumpla con las condiciones de calidad, identificación, estado físico,  ", 25, y, 170);
    y += 5;

    //pdf.text("cantidades y destinos correctos antes de su liberación, reforzando la verificación de pedidos ", 25, y);
    justifyLine(pdf, "cantidades y destinos correctos antes de su liberación, reforzando la verificación de pedidos ", 25, y, 170);
    y += 5;



    //pdf.text("por cliente, el seguimiento de la rotación y fechas de vencimiento del inventario bajo el principio ", 25, y);
    justifyLine(pdf, "por cliente, el seguimiento de la rotación y fechas de vencimiento del inventario bajo el principio ", 25, y, 170);
    y += 5;


    //pdf.text("PEPS, así como el cumplimiento de las condiciones adecuadas de almacenamiento y ", 25, y);
    justifyLine(pdf, "PEPS, así como el cumplimiento de las condiciones adecuadas de almacenamiento y ", 25, y, 170);
    y += 5;

    //pdf.text("transporte, complementado con la capacitación continua del personal involucrado, con el fin de ", 25, y);
    justifyLine(pdf, "transporte, complementado con la capacitación continua del personal involucrado, con el fin de ", 25, y, 170);
    y += 5;

    //pdf.text("minimizar errores, garantizar la trazabilidad y asegurar la calidad del producto distribuido.", 25, y);
    justifyLine(pdf, "minimizar errores, garantizar la trazabilidad y asegurar la calidad del producto distribuido.", 25, y, 170);
    y += 2;

    const img = new Image();

    img.src = firmaMaria;

    img.onload = () => {

        if (img.complete && img.naturalWidth !== 0) {
            pdf.addImage(img, 'PNG', 80, y, 50, 25);
        } else {
            pdf.text("Firma no disponible", 60, 220);
        }
        pdf.save(`Reporte_Devoluciones_${inicio}_${fin}.pdf`);

    }


};
